import {
  GRBAS_ATTRIBUTE_DEFINITIONS,
} from "../grbasConfig";

const ATTRIBUTE_LABELS = Object.fromEntries(
  GRBAS_ATTRIBUTE_DEFINITIONS.map(
    ({ id, label }) => [id, label]
  )
);

export function buildGRBASFeedback({
  response = {},
  reference = {},
} = {}) {
  return Object.keys(ATTRIBUTE_LABELS).map((attribute) => {
    const rawDistribution =
      reference?.[attribute]?.distribution || {};

    return {
      attribute,
      label: ATTRIBUTE_LABELS[attribute],

      userOrdinal:
        response?.[attribute]?.ordinalValue ?? null,

      referenceOrdinal:
        reference?.[attribute]?.referenceOrdinal ?? null,

      distribution: {
        0: Number(rawDistribution[0] || 0),
        1: Number(rawDistribution[1] || 0),
        2: Number(rawDistribution[2] || 0),
        3: Number(rawDistribution[3] || 0),
      },
    };
  });
}
